"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeKonvaStage = exports.initializeKonvaLayer = exports.getShapeDataBasedOnContainer = exports.extraHitSelection = exports.drawShape = exports.drawRect = exports.drawLine = exports.drawEllipse = exports.drawArrow = void 0;
var _konva = _interopRequireDefault(require("konva"));
var _enums = require("../enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initializeKonvaStage = exports.initializeKonvaStage = function initializeKonvaStage(container, width, height, options) {
  return new _konva["default"].Stage(_objectSpread({
    container: container,
    width: width,
    height: height
  }, options));
};
var initializeKonvaLayer = exports.initializeKonvaLayer = function initializeKonvaLayer(options) {
  return new _konva["default"].Layer(_objectSpread({}, options));
};
var drawShape = exports.drawShape = function drawShape(shape, w, h) {
  if (!shape) return;
  var data = getShapeDataBasedOnContainer(shape, w, h);
  switch (shape.shape) {
    case _enums.SHAPE_ENUMS.ARROW:
      return drawArrow(shape, data);
    case _enums.SHAPE_ENUMS.RECT:
      return drawRect(shape, data);
    case _enums.SHAPE_ENUMS.LINE:
      return drawLine(shape, data);
    case _enums.SHAPE_ENUMS.ELLIPSE:
      return drawEllipse(shape, data);
  }
};
var drawArrow = exports.drawArrow = function drawArrow(shape, data) {
  var id = shape.id,
    color = shape.color,
    thickness = shape.thickness;
  var startX = data.startX,
    startY = data.startY,
    endX = data.endX,
    endY = data.endY;
  return new _konva["default"].Arrow({
    id: id,
    points: [startX, startY, endX, endY],
    stroke: color,
    fill: color,
    strokeWidth: thickness
  });
};
var drawRect = exports.drawRect = function drawRect(shape, data) {
  var id = shape.id,
    color = shape.color,
    thickness = shape.thickness;
  var x = data.x,
    y = data.y,
    width = data.width,
    height = data.height;
  return new _konva["default"].Rect({
    id: id,
    x: x,
    y: y,
    width: width,
    height: height,
    stroke: color,
    strokeWidth: thickness
  });
};
var drawLine = exports.drawLine = function drawLine(shape, data) {
  var id = shape.id,
    color = shape.color,
    thickness = shape.thickness;
  var startX = data.startX,
    startY = data.startY,
    endX = data.endX,
    endY = data.endY;
  return new _konva["default"].Line({
    id: id,
    points: [startX, startY, endX, endY],
    stroke: color,
    strokeWidth: thickness,
    lineCap: 'round',
    lineJoin: 'round'
  });
};
var drawEllipse = exports.drawEllipse = function drawEllipse(shape, data) {
  var id = shape.id,
    color = shape.color,
    thickness = shape.thickness;
  var x = data.x,
    y = data.y,
    radiusX = data.radiusX,
    radiusY = data.radiusY;
  return new _konva["default"].Ellipse({
    id: id,
    x: x,
    y: y,
    radiusX: radiusX,
    radiusY: radiusY,
    stroke: color,
    strokeWidth: thickness
  });
};
var getShapeDataBasedOnContainer = exports.getShapeDataBasedOnContainer = function getShapeDataBasedOnContainer(shape, w, h) {
  var data = shape.data;
  switch (shape.shape) {
    case _enums.SHAPE_ENUMS.ARROW:
      return {
        startX: data.startX * w,
        startY: data.startY * h,
        endX: data.endX * w,
        endY: data.endY * h
      };
    case _enums.SHAPE_ENUMS.RECT:
      return {
        x: data.x * w,
        y: data.y * h,
        width: data.width * w,
        height: data.height * h
      };
    case _enums.SHAPE_ENUMS.LINE:
      return {
        startX: data.startX * w,
        startY: data.startY * h,
        endX: data.endX * w,
        endY: data.endY * h
      };
    case _enums.SHAPE_ENUMS.ELLIPSE:
      return {
        x: data.x * w,
        y: data.y * h,
        radiusX: data.radiusX * w,
        radiusY: data.radiusY * h
      };
  }
};
var extraHitSelection = exports.extraHitSelection = 30;
//# sourceMappingURL=overlay-shapes-utils.js.map